<h1 class="zk-mb-2 zk-text-2">
	{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SIGNATURE.TITLE' | translate }}
</h1>
<p class="zk-text-xs">
	{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SIGNATURE.DESCRIPTION' | translate }}
</p>

<img
	*ngIf="data.signatureUrl"
	class="signature-verified--image zk-mb-1 zk-mt-4"
	alt="signature"
	[src]="data.signatureUrl"
/>

<input
	#signatureUploadInput
	hidden
	type="file"
	name="files"
	accept=".png,.jpg,.jpeg"
	style="display: none"
	(change)="onFileChangeEvent($event)"
/>
<button
	zk-button
	zkButtonColor="secondary"
	class="zk-mt-3"
	zkButtonSize="medium"
	(click)="signatureUploadInput.click()"
>
	<ng-container *ngIf="!data.signatureUrl">
		{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SIGNATURE.SEND' | translate }}
	</ng-container>
	<ng-container *ngIf="data.signatureUrl">
		{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SIGNATURE.CHANGE' | translate }}
	</ng-container>
</button>

<div
	class="signature-editor--modal"
	[style.display]="view === 'CLOSED' ? 'none' : 'flex'"
>
	<div class="signature-editor--modal-content">
		<div class="signature-editor--canvas-wrapper">
			<canvas id="canvas"></canvas>
		</div>

		<div class="signature-editor--controls">
			<div *ngIf="view === viewTypes.rotate">
				<p>
					{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__ROTATE_INSTRUCTIONS' | translate }}
				</p>
				<div class="signature-editor--controls-buttons">
					<button class="btn btn-back" (click)="close()">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__CANCEL_EDITING' | translate }}
					</button>
					<button class="btn btn-primary" (click)="changeView(viewTypes.crop)">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__NEXT' | translate }}
					</button>
				</div>
			</div>

			<div *ngIf="view === viewTypes.crop">
				<p>
					{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__CROP_INSTRUCTIONS' | translate }}
				</p>
				<div class="signature-editor--controls-buttons">
					<button class="btn btn-back" (click)="back()">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__BACK' | translate }}
					</button>
					<button
						class="btn btn-primary"
						(click)="changeView(viewTypes.removeBackground)"
					>
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__CROP' | translate }}
					</button>
				</div>
			</div>

			<div *ngIf="view === viewTypes.removeBackground">
				<p>
					{{
						'PAGES.ACCOUNT.FORM.SIGNATURE__REMOVE_BACKGROUND_INSTRUCTIONS'
							| translate
					}}
				</p>
				<input
					class="form-control-range"
					(input)="updateRemoveColorFilterIntensity($event.target.value)"
					type="range"
					min="0"
					max="1"
					step="0.001"
					[value]="removeColorIntensity"
				/>
				<div class="signature-editor--controls-buttons">
					<button class="btn btn-back" (click)="back()">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__BACK' | translate }}
					</button>
					<button
						class="btn btn-primary"
						(click)="changeView(viewTypes.preview)"
					>
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__PREVIEW' | translate }}
					</button>
				</div>
			</div>

			<div *ngIf="view === viewTypes.preview">
				<div class="signature-editor--controls-buttons">
					<button class="btn btn-back" (click)="back()">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__BACK' | translate }}
					</button>
					<button class="btn btn-primary" (click)="saveAndFinish()">
						{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__FINISH_AND_SAVE' | translate }}
					</button>
				</div>
			</div>

			<div *ngIf="view === viewTypes.saving" class="text-center">
				<img
					alt="loading"
					src="/assets/images/preloaders/global_preloader.gif"
				/>
			</div>

			<div *ngIf="view === viewTypes.success" class="text-center">
				<p>
					{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__UPLOAD_SUCCESS' | translate }}
				</p>
			</div>

			<div *ngIf="view === viewTypes.error" class="text-center">
				<p>
					{{ 'PAGES.ACCOUNT.FORM.SIGNATURE__UPLOAD_ERROR' | translate }}
				</p>
			</div>
		</div>
	</div>
</div>
